import { SVG } from '@svgdotjs/svg.js';

export function drawOnFlat(){
    const $block = $('#select_flat')
    const $drawingBlock = $block.find('[data-drawing-block]');

    if (!$drawingBlock.length) {
        return
    }

    const $drawing = $drawingBlock.find('[data-drawing]');
    const $popupDesktop = $('#popup_desktop')
    const $popupMobile = $('#popup_mobile')

    const items = $drawingBlock.data('items');

    const drawingPaths = [];

    const drawingOptions = {
        id: $drawing.attr('id'),
        image: $drawing.attr('data-image'),
        colorBase: 'rgba(255, 255, 255, 0.3)',
        colorFill: 'rgba(255, 255, 255, 0)',
        pathFill: 'rgba(20, 30, 48, 0.4)',
        pathBase:'rgba(20, 30, 48, 0)',
        stroke: { color: '#243B55', opacity: 1, width: 2, dasharray: '7' },
        width: 1920,
        height: 1080
    }

    init();

    function init(){
        drawingInit();
        drawingResize();
        initEventsHandler();
    }

    function initEventsHandler(){
        $(window).on('resize',function (){
            drawingResize();
        })
    }

    function drawingResize() {
        const kHW = 0.5625;
        const kWH = 1.77777777777777;

        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;
        const kWindow = windowHeight / windowWidth;

        let widthDrawing = windowHeight * kWH;
        let heightDrawing = windowHeight;

        if (kWindow < kHW) {
            widthDrawing = windowWidth;
            heightDrawing = windowWidth * kHW;
        }


        let marginTop = heightDrawing / 2;
        if (heightDrawing > innerHeight) {
            const diff = innerHeight - heightDrawing;
            marginTop -= diff / 2;
        }

        $drawing.css({
            width: `${widthDrawing}px`,
            height: `${heightDrawing}px`,
            marginLeft: `${-widthDrawing / 2}px`,
            marginTop: `${-marginTop}px`
        });

        if (!isDesktop()) {
            $drawingBlock.scrollLeft(widthDrawing / 5);
        }
    }

    function drawingInit() {
        const draw = SVG().addTo(`#${drawingOptions.id}`);
        draw.viewbox(0, 0, drawingOptions.width, drawingOptions.height);

        console.log(items)
        let image = draw.image(drawingOptions.image);
// Устанавливаем размеры картинки
        image.size("100%", "100%").move(0, 0);

        items.forEach(data => {
            addPolygonItem(draw, data);
        })
    }

    function addPolygonItem(draw,item){

        const polygon = draw.polygon(item.coords).fill(drawingOptions.colorBase).stroke(drawingOptions.stroke).data({
            id: item.id,
            section: item.section,
            floor: item.floor,
            first_flat: item.first_flat  || '',
            second_flat:item.second_flat  || '',
            third_flat:item.third_flat  || '',
            studio_flat:item.studio_flat || '',
            first_flat_area: item.first_flat_area  || '',
            second_flat_area:item.second_flat_area  || '',
            third_flat_area:item.third_flat_area  || '',
            studio_flat_area:item.studio_flat_area || '',
            coords:item.coords,
            link: item.link,
            path: item.path
        }).css('cursor','pointer')
        draw.add(polygon);
        drawingPaths[item.id] = draw.path(item.path);
        drawingPaths[item.id].fill(drawingOptions.pathBase).css({
            'visibility':'hidden',
            'pointer-events':'none',
            'transition':'fill .3s linear'
        })


        initPolyEventsHandler(polygon);

    }

    function initPolyEventsHandler(item){
        if(isDesktop()) {
            item.mouseover(function () {
                this.fill(drawingOptions.colorFill)
                console.log(drawingPaths[item.data('id')])
                drawingPaths[item.data('id')].fill(drawingOptions.pathFill).css({
                    'visibility':'visible',
                })

                setModalContent(item);
                openModal(item);
            })
                .mouseout(function () {
                    this.fill(drawingOptions.colorBase)
                    drawingPaths[item.data('id')].fill(drawingOptions.pathBase).css({
                        'visibility':'visible',
                    })
                    closeModal();
                })
                .click(function (){
                    window.location.href = item.data('link');
                })
        } else {
            item.click(function () {
                if($('.popup-mobile .popup-wrapper').hasClass('active')) return;
                $('.popup-mobile .popup-wrapper').addClass('active');
                    this.fill(drawingOptions.colorFill)
                drawingPaths[item.data('id')].fill(drawingOptions.pathFill).css({
                    'visibility':'visible',
                })
                setMobileModalContent(item);
                openModalMobile();
                console.log($('.popup-mobile .close-popup'))
                $('.popup-mobile .close-popup').on('click',function (){
                    $('.popup-mobile .popup-wrapper').removeClass('active');
                    item.fill(drawingOptions.colorBase)
                    drawingPaths[item.data('id')].fill(drawingOptions.pathBase).css({
                        'visibility':'visible',
                    })
                    closeModalMobile();
                })
            })


        }
    }

    function setModalContent(item){

        let result = ``;

        const data = item.data();

        if(data.studio_flat){
            result += `      
              <div class="item">
                <div class="room">C</div>
                <div class="count">
                  ${data.studio_flat}
                  <span class="nowrap area">от ${data.studio_flat_area} кв.м</span>
                </div>
              </div>`
        }
        if(data.first_flat){
            result += `      
              <div class="item">
                <div class="room">1</div>
                <div class="count">
                  ${data.first_flat}
                  <span class="nowrap area">от ${data.first_flat_area} кв.м</span>
                </div>
              </div>`
        }
        if(data.second_flat){
            result += `      
              <div class="item">
                <div class="room">2</div>
                <div class="count">
                  ${data.second_flat}
                  <span class="nowrap area">от ${data.second_flat_area} кв.м</span>
                </div>
              </div>`
        }
        if(data.third_flat){
            result += `      
              <div class="item">
                <div class="room">3</div>
                <div class="count">
                  ${data.third_flat}
                  <span class="nowrap area">от ${data.third_flat_area} кв.м</span>
                </div>
              </div>`
        }

        $popupDesktop.find('.container').prepend(
            `
                <div class="top-text">
                  <div class="section-name"><h3 class="h3 color-white no-padding">${data.section}</h3> секция</div>
                  <div class="floor"><h3 class="h3 color-white no-padding">${data.floor}</h3> этаж</div>
                </div>
                <div class="bottom-text">
                </div>
            `
        ).find('.bottom-text').append(result);
    }

    function setMobileModalContent(item){
        let result = ``;

        const data = item.data();

        if(data.studio_flat){
            result += `      
              <div class="item">
                <div class="room">C</div>
                <div class="count">
                  ${data.studio_flat}
                  
                 <span class="nowrap area">от ${data.studio_flat_area} кв.м</span>
                </div>
              </div>`
        }
        if(data.first_flat){
            result += `      
              <div class="item">
                <div class="room">1</div>
                <div class="count">
                  ${data.first_flat}
                  <span class="nowrap area">от ${data.first_flat_area} кв.м</span>
                </div>
              </div>`
        }
        if(data.second_flat){
            result += `      
              <div class="item">
                <div class="room">2</div>
                <div class="count">
                  ${data.second_flat}
                  <span class="nowrap area">от ${data.second_flat_area} кв.м</span>
                </div>
              </div>`
        }
        if(data.third_flat){
            result += `      
              <div class="item">
                <div class="room">3</div>
                <div class="count">
                  ${data.third_flat}
                  <span class="nowrap area">от ${data.third_flat_area} кв.м</span>
                </div>
              </div>`
        }

        $popupMobile.find('.container .popup-wrapper').append(`      <div class="top-text">
        <div class="section-name"><h3 class="h3 color-white no-padding">${data.section}</h3> секция</div>
        <div class="floor"><h3 class="h3 color-white no-padding">${data.floor}</h3> этаж</div>
        <img class="close-popup" src="/img/icons/close-btn.svg">
      </div>`).append(result);
        $popupMobile.find('.container .button').attr('href', data.link)
    }

    function openModal(item){
        const data = item.node.getBoundingClientRect();

        const bottomSpace = window.innerHeight - data.bottom;
        const minHeight = window.innerHeight - window.innerHeight * 0.45;
        if (data.top > minHeight) {
            $popupDesktop.css('bottom', bottomSpace).css('left',data.left+data.width+20).removeClass('hide');
        } else {
            $popupDesktop.css('top',data.top).css('left',data.left+data.width+20).removeClass('hide');
        }
    }
    function openModalMobile(){
        $popupMobile.removeClass('hide')
    }

    function closeModal(){
        $popupDesktop.css('top','').css('bottom',0).addClass('hide').find('.container').empty();
    }

    function closeModalMobile(){
        $popupMobile.addClass('hide').find('.container  .popup-wrapper').empty();
    }

    function isDesktop(){
        return (window.innerWidth > 1000);
    }

}
